import { render } from "./HeroiconsOutlineArrowRight.vue?vue&type=template&id=6aaf4396"
const script = {}

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowRight.vue"]])

export default __exports__